import { $getSelection, $isRangeSelection } from 'lexical';
import * as Constants from 'const';

export function $getCharStyle(): Constants.CharStyle[] {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return [];
  }
  const result: Constants.CharStyle[] = [];

  if (selection.hasFormat('bold')) {
    result.push(Constants.CharStyle.BOLD);
  }

  if (selection.hasFormat('italic')) {
    result.push(Constants.CharStyle.ITALIC);
  }

  if (selection.hasFormat('underline')) {
    result.push(Constants.CharStyle.UNDERLINE);
  }

  return result;
}
